import api from "./api";

export const deleteMyBankAccount = async (id) => {
  return api
    .delete({
      endpoint: `/bank-account/${id}`,
      port: process.env.REACT_APP_PORT_VENUE,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
